import React from "react"

function Footer() {
  return (
    <section id="footer">
      <div className="inner">
        <ul className="copyright">
          <li>&copy; IntouchCare Inc. All rights reserved.</li>
        </ul>
      </div>
    </section>
  )
}

export default Footer
